import { render } from "./PrefNave.vue?vue&type=template&id=22f9e845&scoped=true"
import script from "./PrefNave.vue?vue&type=script&lang=js"
export * from "./PrefNave.vue?vue&type=script&lang=js"

import "./PrefNave.vue?vue&type=style&index=0&id=22f9e845&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f9e845"]])

export default __exports__